import { SVGProps, Ref, forwardRef } from 'react'
const SvgCalendarRefresh = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M5.25 0A.75.75 0 0 1 6 .75v.75h6V.75a.75.75 0 0 1 1.5 0v.75h2.25A2.25 2.25 0 0 1 18 3.75v4.5a.75.75 0 0 1-1.5 0V7.5h-15v8.25a.75.75 0 0 0 .75.75h6a.75.75 0 0 1 0 1.5h-6A2.25 2.25 0 0 1 0 15.75v-12A2.25 2.25 0 0 1 2.25 1.5H4.5V.75A.75.75 0 0 1 5.25 0ZM12 3v.75a.75.75 0 0 0 1.5 0V3h2.25a.75.75 0 0 1 .75.75V6h-15V3.75A.75.75 0 0 1 2.25 3H4.5v.75a.75.75 0 0 0 1.5 0V3h6Zm-1.5 15.75a.75.75 0 0 1 .75-.75H15a.75.75 0 0 1 0 1.5h-2.069a4.822 4.822 0 0 0 9.027-.26.75.75 0 0 1 1.42.487A6.323 6.323 0 0 1 12 20.971V22.5a.75.75 0 0 1-1.5 0v-3.75Zm12.75-7.5A.75.75 0 0 1 24 12v3.75a.75.75 0 0 1-.75.75H19.5a.75.75 0 0 1 0-1.5h2.069a4.821 4.821 0 0 0-9.027.26.75.75 0 1 1-1.42-.486A6.323 6.323 0 0 1 22.5 13.527V12a.75.75 0 0 1 .75-.75Z"
      clipRule="evenodd"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCalendarRefresh)
export default ForwardRef
